import { userConstants } from '../constants';

// let user = JSON.parse(localStorage.getItem('user'));
// const initialState = user ? { isLoginProgressing: false, loggedIn: true, user } : {};
const initialState = { isLoginProgressing: false, loggedIn: false,isLogoutProgressing: false, logOut: false };

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        ...state,
        isLoginProgressing: true,
        user: action.user
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        ...state,
        isLoginProgressing: false,
        isLoggined: true
      };
    case userConstants.LOGIN_FAILURE:
      return {};
    // case userConstants.LOGOUT:
    //   return {};
    case userConstants.LOGOUT_REQUEST:
      return {
        ...state,
        isLogoutProgressing: true,
        user: action.user
      };
    case userConstants.LOGOUT_SUCCESS:
      return {
        ...state,
        isLogoutProgressing: false,
        isLogout: true
      };
    case userConstants.LOGOUT_FAILURE:
      return {};
    default:
      return state
  }
}
